import Timer from 'tick-tock';
import scrollTo from 'animated-scroll-to';

export default class Anchors {
  constructor() {
    this.id = '';
    this.offset = 20;

    // Listen for click events on links starting with a hash.
    // If an id'd element exists, scroll to it.
    const anchors = document.querySelectorAll('a[href^="#"]');
    anchors.forEach((anchor) => {
      anchor.addEventListener('click', this.clickHandler.bind(this));
    });

    // Manage URLs containing a hash
    // If an id'd element exists, scroll to it.
    if (window.location.hash) {
      this.id = window.location.hash.substr(1);
      this.goToCurrentAnchor();
    }
  }

  clickHandler(event) {
    // Prevent default browser based hash functionality.
    event.preventDefault();

    // Extract the hash to use as the element id to search for.
    this.id = event.currentTarget.href.substr(event.currentTarget.href.indexOf('#') + 1);

    // Locate destination within the document.
    const destination = document.getElementById(this.id);

    // Quit if the destination isn't found
    if (!destination) return;

    // Scroll to destination.
    this.scrollToDestination(destination);
  }

  scrollToDestination(destination) {
    scrollTo(destination, {
      elementToScroll: window,
      verticalOffset: this.offset,
      maxDuration: 1000,
      minDuration: 250,
      speed: 1000,
    }).then(() => {
      // Focus the element we scrolled to after we scroll down to it.
      const { scrollX, scrollY } = window;
      destination.focus();
      window.scrollTo(scrollX, scrollY);
    });
  }

  goToCurrentAnchor() {
    const anchor = document.getElementById(this.id);
    if (anchor) {
      const timer = new Timer();
      timer.setTimeout('setCurrentAnchor', () => {
        this.scrollToDestination(anchor);
        timer.clear('setCurrentAnchor');
      }, 500);
    }
  }
}
